import CONTRATO_CATALOGO_FAVORITOS from '@/graphql/querys/administracion/contratos/contrato/catalogofavoritos/contratoCatalogoFavoritos.gql';
import CONTRATO_ACTIVIDADES from '@/graphql/querys/administracion/contratos/contrato/reporteactividades/contratoActividades.gql';
import CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/contrato/avanceReal/contratoCatalogoConceptos.gql';
import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';
import CONTRATO_PROGRAMAS_OBRAS from '@/graphql/querys/administracion/contratos/programa/contratoProgramasObra.gql';

import mixAvanceProgramado from '@/helpers/calculos/mixAvanceProgramado';

export default {
  mixins: [mixAvanceProgramado],

  apollo: {
    contratoProgramasObra: {
      query: CONTRATO_PROGRAMAS_OBRAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoCatalogoFavoritos: {
      query: CONTRATO_CATALOGO_FAVORITOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoActividades: {
      query: CONTRATO_ACTIVIDADES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoCatalogoConceptos: {
      query: CONTRATO_CATALOGO_CONCEPTOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoEstimaciones: {
      query: CONTRATO_ESTIMACIONES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },

  computed: {
    getProgramaDeObra() {
      if (!this.contratoProgramasObra) return [];
      const { programa } = this.contratoProgramasObra[0];
      if (!programa) return [];
      return programa
        .map((prog) => {
          const importeContratado = this.getImporteContratado;
          const fecha = new Date(`${prog.fechaTermino} 00:00:0`);
          const programaAcumulado = programa
            .filter(({ fechaTermino }) => new Date(`${fechaTermino} 00:00:0`) <= fecha);
          const importeProgramadoAcumulado = this.$ObjSumar(programaAcumulado, 'monto');
          const porcentaje = this.$numberRound(
            (importeProgramadoAcumulado / importeContratado)
            * 100,
          );

          return {
            ...prog,
            fecha,
            importeProgramadoAcumulado,
            porcentaje,
          };
        })
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    },
    getImporteContratado() {
      if (!this.contrato) return 0;
      return (this.contrato.importe + (this.contrato.modificado.importe));
    },
    importeDelContrato() {
      return this.getImporteContratado;
    },
    getContratoCatalogoFavoritos() {
      if (!this.contratoCatalogoFavoritos) return [];
      return this.contratoCatalogoFavoritos
        .slice()
        .map((favorito) => {
          const { estimado, avancesReales, cantidad } = favorito.concepto;

          const estimacionesFiltradas = estimado
            .filter(({ estimacion }) => new Date(`${estimacion.fechaAl} 00:00:0`) <= new Date(`${this.AlaFecha} 00:00:0`));

          const avancesRealesFiltradas = avancesReales
            .filter(({ fecha }) => new Date(`${fecha} 00:00:0`) <= new Date(`${this.AlaFecha} 00:00:0`));

          const cantidadEstimado = this.$ObjSumar(estimacionesFiltradas, 'cantidad');
          const cantidadAvance = this.$ObjSumar(avancesRealesFiltradas, 'cantidad');

          const total = (cantidadEstimado + cantidadAvance);

          const porcentajeAvance = Math.ceil(((total / cantidad) * 100));

          return {
            ...favorito,
            porcentajeAvance: porcentajeAvance > 100 ? 100 : porcentajeAvance,
          };
        })
        .sort((a, b) => a.orden - b.orden);
    },
    getContratoActividades() {
      if (!this.contratoActividades) return [];
      return this.contratoActividades;
    },
    getActividadTipoAlbum() {
      return this.getContratoActividades
        .filter(({ tipo }) => tipo === 3)
        .filter(({ fecha }) => new Date(`${fecha} 00:00:0`) <= new Date(`${this.AlaFecha} 00:00:0`))
        .map((actividad) => ({
          ...actividad,
          imagenes: actividad.imagenes.map((img) => `${this.$urlFileServer}/${img}`),
        }))
        .sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`));
    },
    getUltimoReporteActividad() {
      if (this.getActividadTipoAlbum.length <= 0) return null;
      return this.getActividadTipoAlbum[0];
    },
    getRepoortesExeptoElUltimo() {
      if (!this.getUltimoReporteActividad) return this.getActividadTipoAlbum;
      return this.getActividadTipoAlbum
        .filter(({ id }) => id !== this.getUltimoReporteActividad.id);
    },
    getEstimaciones() {
      if (!this.contratoEstimaciones) return [];
      return this.contratoEstimaciones;
    },
    getImporteEstimadoAlaFecha() {
      const estimaciones = this.getEstimaciones
        .slice()
        .filter(({ fechaAl }) => new Date(`${fechaAl} 00:00:0`) <= new Date(`${this.AlaFecha} 00:00:0`));
      return this.$ObjSumar(estimaciones, 'importeEstimado');
    },
    getPorcentajeFinanciero() {
      return this.$numberRound(((this.getImporteEstimadoAlaFecha
      / this.getImporteContratado) * 100));
    },
    getCatalogoConceptosAvances() {
      if (!this.contratoCatalogoConceptos) return [];
      return this.contratoCatalogoConceptos;
    },
    getCatalogoConceptosAvancesAlaFecha() {
      if (!this.contratoCatalogoFavoritos) return [];
      return this.contratoCatalogoFavoritos
        .slice()
        .map(({ concepto }) => {
          const { avancesReales } = concepto;
          const avancesRealesCopy = [...avancesReales]
            .filter(({ fecha }) => new Date(`${fecha} 00:00:0`) <= new Date(`${this.AlaFecha} 00:00:0`))
            .sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`));

          if (!avancesRealesCopy[0]) {
            return [];
          }

          return {
            ...avancesRealesCopy[0],
            fechaFormat: new Date(`${avancesRealesCopy[0].fecha} 00:00:0`),
          };
        })
        .flat();
    },
    getImporteCatalogoConceptosAvancesAlaFecha() {
      return this.$ObjSumar(this.getCatalogoConceptosAvancesAlaFecha, 'importe');
    },
    getPorcentajeAvanceFisicoAlaFecha() {
      const importe = (this.getImporteCatalogoConceptosAvancesAlaFecha
      + this.getImporteEstimadoAlaFecha);

      const porcentaje = this.$numberRound(((importe
      / this.getImporteContratado) * 100));

      return porcentaje > 100 ? 100 : porcentaje;
    },
    getGraficaEstimacionesData() {
      const AlaFecha = new Date(`${this.AlaFecha}T00:00:00Z`);

      return [...this.getEstimaciones].map(({ fechaDel, fechaAl, importeEstimado }) => {
        const importeContratado = this.getImporteContratado;
        const fecha = new Date(`${fechaAl}T00:00:00Z`);
        const estimacionesAcumuladas = this.getEstimaciones
          .filter((estimacion) => new Date(`${estimacion.fechaAl}T00:00:00Z`) <= fecha);
        const importeEstimadoAcumulado = this.$ObjSumar(estimacionesAcumuladas, 'importeEstimado');
        const porcentaje = this.$numberRound(
          (importeEstimadoAcumulado / importeContratado)
            * 100,
        );
        return {
          fecha,
          fechaDel,
          fechaAl,
          porcentaje,
          importeEstimadoAcumulado,
          importeEstimado,
        };
      })
        .filter(({ fecha }) => new Date(fecha) <= AlaFecha)
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    },
    getGraficaFechasEstimaciones() {
      const AlaFecha = new Date(`${this.AlaFecha} 00:00:0`);

      return [...this.getGraficaEstimacionesData]
        .filter(({ fecha }) => new Date(fecha) <= AlaFecha)
        .map(({ fecha, fechaAl }) => ({
          fecha, fechaAl,
        }))
        .sort((a, b) => new Date(a) - new Date(b));
    },
    getGraficaFechasAvanceFisico() {
      // Fechas de la estimaciones
      const estimacionesFechas = [...this.getGraficaFechasEstimaciones];
      // get el ultimo registro
      const ultimaFechaEstiamcion = estimacionesFechas.slice(-1)[0]?.fecha || null;

      const fechasAvancesFisicos = [...this.getCatalogoConceptosAvancesAlaFecha]
        .filter(({ fechaFormat }) => {
          if (!ultimaFechaEstiamcion) return true;

          return new Date(fechaFormat) > new Date(ultimaFechaEstiamcion);
        })
        .map(({ fecha, fechaFormat }) => ({
          fecha,
          fechaFormat,
        }))
        .sort((a, b) => new Date(b.fechaFormat) - new Date(a.fechaFormat));

      // Regresar la ultima fecha del avance
      if (!fechasAvancesFisicos[0]) {
        return [];
      }
      return [fechasAvancesFisicos[0]];
    },
    getGraficaFechasProgramado() {
      // Fechas de la estimaciones
      const estimacionesFechas = [...this.getGraficaFechasEstimaciones];
      // get el ultimo registro
      const ultimaFechaEstiamcion = estimacionesFechas.slice(-1)[0]?.fecha || null;
      // Fechas de avance
      const avancesFechas = [...this.getGraficaFechasAvanceFisico];
      // set Ultima fecha del avance fisico
      const ultimaFechaAvanceFisico = avancesFechas[0]?.fechaFormat || null;

      return [...this.getProgramaDeObra]
        .filter(({ fecha }) => {
          if (ultimaFechaAvanceFisico) {
            return new Date(fecha) > new Date(ultimaFechaAvanceFisico);
          }
          if (ultimaFechaEstiamcion) {
            return new Date(fecha) > new Date(ultimaFechaEstiamcion);
          }

          return true;
        })
        .map(({ fecha, fechaTermino }) => ({
          fecha,
          fechaTermino,
        }))
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    },
    getGraficaEjeX() {
      const fechas = [
        ...this.getGraficaFechasEstimaciones.map(({ fechaAl }) => fechaAl),
        ...this.getGraficaFechasAvanceFisico.map(({ fecha }) => fecha),
        ...this.getGraficaFechasProgramado.map(({ fechaTermino }) => fechaTermino),
      ].sort((a, b) => new Date(a) - new Date(b));

      // Selecccionar primera fecha
      const [primeraFecha] = fechas;

      // Filtrar fechas del programado
      const fechasProgramado = [...this.getProgramaDeObra]
        .filter(({ fecha }) => new Date(fecha) < new Date(primeraFecha));

      return [
        ...fechasProgramado.map(({ fechaTermino }) => fechaTermino),
        ...fechas,
      ].sort((a, b) => new Date(a) - new Date(b));
    },
    getGraficaProgramadoData() {
      if (this.getGraficaEjeX.length <= 0) return [];

      const fechas = this.getGraficaEjeX;
      const programado = [];

      fechas.forEach((fecha) => {
        // Buscar avance programado a la fecha
        // const getAvance = this.getProgramaDeObra
        //  .find((avance) => avance.fechaTermino === fecha);
        // Comprobar si no existe un registro
        // if (!getAvance) {
        // Si no existe, entonces calculamos el programado a la fecha
        programado.push(this.mixCalcularPrograma(fecha));
        // } else {
        // Si no se agrega el avance
        // programado.push(getAvance);
        // }
      });

      // se regresa los programado
      return programado;
    },
    getGraficaAvanceFisicoData() {
      const importeContratado = this.getImporteContratado;

      // Fechas ordenadas menor a mayor
      const fechasOrdenadasMenorMayor = [
        ...this.getGraficaFechasEstimaciones.map(({ fecha }) => fecha),
        ...this.getGraficaFechasAvanceFisico.map(({ fechaFormat }) => fechaFormat),
      ]
        .sort((a, b) => new Date(a) - new Date(b));

      // Selecccionar primera fecha
      const [primeraFecha] = fechasOrdenadasMenorMayor;

      // Filtrar fechas del programado
      const fechasProgramado = [...this.getProgramaDeObra]
        .filter(({ fecha }) => new Date(fecha) < new Date(primeraFecha));

      // Todas las fechas
      const fechas = [
        ...fechasProgramado.map(({ fecha }) => fecha),
        ...this.getGraficaFechasEstimaciones.map(({ fecha }) => fecha),
        ...this.getGraficaFechasAvanceFisico.map(({ fechaFormat }) => fechaFormat),
      ]
        .sort((a, b) => new Date(a) - new Date(b));

      // Avances fisicos
      const avanceFisico = [];

      fechas.forEach((fecha) => {
        // Filtrar los avances fisicos a la fecha
        const avancesFisicosAlaFecha = [...this.getCatalogoConceptosAvancesAlaFecha]
          .filter(({ fechaFormat }) => new Date(fechaFormat) <= new Date(fecha));
          // Sumar el importe de los avances encontrados
        const importeAvanceFisico = this.$ObjSumar(avancesFisicosAlaFecha, 'importe');
        // Filtrar estimaciones a la fecha
        const estimaciones = [...this.getGraficaEstimacionesData]
          .filter((est) => new Date(est.fecha) <= new Date(fecha));
          // Importe de la suma de las estimaciones
        const importeEstimado = this.$ObjSumar(estimaciones, 'importeEstimado');

        // Total de avance fisico (fisico + estimado)
        const totalAvance = this.$numberRound((importeAvanceFisico + importeEstimado));

        // Porcentaje de avance fisico real
        const porcentaje = this.$numberRound(((totalAvance / importeContratado) * 100));

        // Agregar el avance real al array
        avanceFisico.push({
          importe: totalAvance,
          porcentaje,
        });
      });

      // Regresar los avances fisicos
      return avanceFisico;
    },
  },
};
